if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickATC extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        let tidio = null;
        const parent = this;
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const isHidden =
                (entry.isIntersecting && entry.boundingClientRect.top <= 100) || entry.boundingClientRect.top > 100;
              parent.classList.toggle('hidden', isHidden);
              if (tidio) tidio.style.bottom = isHidden ? '35px' : '70px';
            });
          },
          {
            root: null,
            rootMargin: '-100px',
            threshold: 0,
          }
        );

        document.querySelectorAll(this.dataset.target).forEach((el) => {
          observer.observe(el);
        });

        const domObserver = new MutationObserver(
          (mutations, obs) => {
            mutations.forEach((record) => {
              record.addedNodes.forEach(el => {
                if (el.id === 'tidio-chat-iframe') {
                  tidio = el;
                  setTimeout(() => {
                    tidio.style.bottom = parent.classList.contains('hidden') ? '35px' : '70px';
                  }, 200)
                  obs.disconnect();
                }
              });
            });
          }
        );

        domObserver.observe(document.body, {childList: true, subtree: true})
      }
    }
  );
}
